<template>
  <v-container>
    <v-col cols="12" v-for="(i, index) in enderecos.length" :key="i">
      <v-row>
        <v-col cols="12" md="12">
          <v-text-field
            @change="emit"
            v-model="enderecos[index].descricao"
            :label="$t('Descricao')"
            name="descricao"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          />
        </v-col>

        <v-col v-if="possuiTransporteValores" cols="12" md="12">
          <CampoRelacionamentoCadastroRapido
            :value="enderecos[index].classificacao"
            @input="setClassificacao(index, $event)"
            url="clienteEnderecoClassificacoes"
            cadastro-url="cadastro.ClienteEnderecoClassificacao"
            label="ClienteEnderecoClassificacao"
          />
        </v-col>

        <v-col cols="12" md="4">
          <BuscaCep
            @cidades="cidades = $event"
            @bairro="enderecos[index].bairro = $event"
            @cep="enderecos[index].cep = $event"
            @cidade="enderecos[index].cidade = $event"
            @uf="enderecos[index].uf = $event"
            @logradouro="enderecos[index].logradouro = $event"
            :cepProp="enderecos[index].cep || ''"
            :carregar-cidades="false"
          ></BuscaCep>
        </v-col>

        <v-col cols="12" md="6">
          <v-text-field
            @change="emit"
            :label="$t('Cidade')"
            v-model="enderecos[index].cidade"
            name="cidade"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          >
          </v-text-field>
        </v-col>

        <v-col cols="12" md="2">
          <v-text-field
            @change="emit"
            :label="$t('UF')"
            v-model="enderecos[index].uf"
            name="uf"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          >
          </v-text-field>
        </v-col>

        <v-col cols="12">
          <v-text-field
            @change="emit"
            v-model="enderecos[index].logradouro"
            :label="$t('Logradouro')"
            name="logradouro"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          >
          </v-text-field>
        </v-col>

        <v-col cols="12" md="12">
          <v-text-field
            @change="emit"
            v-model="enderecos[index].bairro"
            :label="$t('Bairro')"
            name="bairro"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          />
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            @change="emit"
            @blur="buscaGeoCode(index)"
            v-model="enderecos[index].numero"
            :label="$t('Numero')"
            name="numero"
            type="number"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          >
          </v-text-field>
        </v-col>

        <v-col cols="12" md="6">
          <v-text-field
            @change="emit"
            v-model="enderecos[index].complemento"
            :label="$t('Complemento')"
            name="complemento"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          />
        </v-col>

        <v-col cols="12" md="6">
          <v-text-field
            @change="emit"
            v-model="enderecos[index].latitude"
            :label="$t('Latitude')"
            name="latitude"
            type="number"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          />
        </v-col>

        <v-col cols="12" md="6">
          <v-text-field
            @change="emit"
            v-model="enderecos[index].longitude"
            :label="$t('Longitude')"
            name="longitude"
            type="number"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          />
        </v-col>

        <v-row v-if="possuiTransporteValores">
          <v-col cols="12" md="6">
            <v-text-field
              v-model="enderecos[index].codigoIntegracaoExterna01"
              :label="$t('codigoIntegracaoExterna01')"
              name="codigoIntegracaoExterna01"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="enderecos[index].codigoIntegracaoExterna02"
              :label="$t('codigoIntegracaoExterna02')"
              name="codigoIntegracaoExterna02"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="enderecos[index].codigoIntegracaoExterna03"
              :label="$t('codigoIntegracaoExterna03')"
              name="codigoIntegracaoExterna03"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            />
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field
              v-model="enderecos[index].codigoIntegracaoBancaria01"
              :label="$t('codigoIntegracaoBancaria01')"
              name="codigoIntegracaoBancaria01"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="enderecos[index].codigoIntegracaoBancaria02"
              :label="$t('codigoIntegracaoBancaria02')"
              name="codigoIntegracaoBancaria02"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="enderecos[index].codigoIntegracaoBancaria03"
              :label="$t('codigoIntegracaoBancaria03')"
              name="codigoIntegracaoBancaria03"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="enderecos[index].codigoIdentificacaoReciproca"
              :label="$t('codigoIdentificacaoReciproca')"
              name="codigoIdentificacaoReciproca"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="enderecos[index].codigoBanco"
              :label="$t('codigoBanco')"
              name="codigoBanco"
              class="
                input-style
                font-size-input
                text-light-input
                placeholder-light
                input-icon
              "
              dense
              flat
              filled
              solo
            />
          </v-col>
        </v-row>
      </v-row>
    </v-col>

    <v-col cols="12" class="text-right">
      <v-btn
        height="39"
        class="
          font-weight-bold
          text-capitalize
          btn-ls btn-secondary
          bg-gradient-light
          py-3
          px-6
        "
        v-if="enderecos.length > 1"
        @click="removeEndereco"
      >
        <v-icon dark> mdi-minus </v-icon>
      </v-btn>

      <v-btn
        rounded
        @click="addEndereco"
        class="
          ma-1
          font-weight-bold
          text-none
          btn-primary
          bg-gradient-primary
          py-3
          px-6
          ms-3
        "
        height="39"
      >
        {{ $t("Adicionar_endereco") }}
      </v-btn>
    </v-col>
  </v-container>
</template>

<script>
import BuscaCep from "@/components/base/proprios/BuscaCepSimplified";
import CampoRelacionamentoCadastroRapido from "@/components/base/proprios/CampoRelacionamentoCadastroRapido";
export default {
  name: "FormEndereco",

  components: { BuscaCep, CampoRelacionamentoCadastroRapido },

  props: {
    payload: { type: Array, required: false },
    possuiTransporteValores: { type: Boolean, required: false, default: false },
  },

  mounted() {
    if (this.payload) {
      if (this.payload.length > 0) {
        this.enderecos = this.payload.map((endereco) => ({
          ...this.enderecoVazio,
          ...endereco,
        }));
      }
    }
  },

  data() {
    return {
      cidades: [],

      enderecos: [
        {
          cidade: "",
          uf: "",
          bairro: "",
          logradouro: "",
          latitude: "",
          longitude: "",
          codigoIntegracaoExterna01: "",
          codigoIntegracaoExterna02: "",
          codigoIntegracaoExterna03: "",

          codigoIntegracaoBancaria01: "",
          codigoIntegracaoBancaria02: "",
          codigoIntegracaoBancaria03: "",
          codigoIdentificacaoReciproca: "",
          codigoBanco: "",
        },
      ],

      enderecoVazio: {
        cidade: "",
        uf: "",
        bairro: "",
        logradouro: "",
        latitude: "",
        longitude: "",
        codigoIntegracaoExterna01: "",
        codigoIntegracaoExterna02: "",
        codigoIntegracaoExterna03: "",

        codigoIntegracaoBancaria01: "",
        codigoIntegracaoBancaria02: "",
        codigoIntegracaoBancaria03: "",
        codigoIdentificacaoReciproca: "",
        codigoBanco: "",
      },
    };
  },

  methods: {
    addEndereco() {
      this.enderecos.push({ ...this.enderecoVazio });
    },

    removeEndereco() {
      this.enderecos.pop();
    },

    emit() {
      this.$emit("recursos", this.enderecos);
    },

    setClassificacao(index, classificacao) {
      this.$set(
        this.enderecos[index],
        "classificacao",
        classificacao && classificacao.id
          ? { id: classificacao.id, descricao: classificacao.descricao }
          : null
      );
      this.emit();
    },

    buscaGeoCode(index) {
      console.log(index, "index");
      let geocoder = new google.maps.Geocoder();

      let end = this.enderecos[index];
      console.log(end);
      let address =
        end.logradouro + ", " + end.numero + ", " + end.bairro + " " + end.cep;

      geocoder.geocode(
        {
          address: address,
          region: "br",
          componentRestrictions: { country: "BR" },
        },
        (results, status) => {
          if (status == "OK") {
            let lat = results[0].geometry.location.lat();
            let lng = results[0].geometry.location.lng();
            this.enderecos[index].latitude = lat;
            this.enderecos[index].longitude = lng;
          } else {
            console.log(
              "Geocode was not successful for the following reason: " + status
            );
          }
        }
      );
    },
  },

  watch: {
    enderecos: function (newValue) {
      this.$emit("recursos", newValue);
    },
  },
};
</script>

<style></style>
